import React from "react";
import { cn } from "@/utils/utils";

import Website from "@/common/constants/webstite";
import { StoryCollectionJson } from "@/types/StoryCollection.type";

import Image from "@/components/ui/Image";
import LinkElement from "@/components/LinkElement";
import TextDateTime from "@/components/TextDateTime";
import ImageConstant from "@/common/constants/image";

type Props = {
  data: StoryCollectionJson;
  className?: string;
  classNameImage?: string;
  classNameTitle?: string;
  subTitle?: "datePublished" | "children";
};
export default function CollectionCard({
  data,
  className,
  classNameImage,
  classNameTitle,
  subTitle = "datePublished",
}: Props) {
  return (
    <LinkElement
      href={`${
        data?.handle ? `${Website.LINK.PAGE.BLOG}/${data?.handle}` : ""
      }`}
      className={cn("relative", className)}
    >
      <Image
        src={data?.images[0]?.url || ""}
        width={400}
        height={400}
        alt={data.title}
        objectFit={"cover"}
        className={cn(
          "object-cover w-full h-[w-full] md:max-h-[336px]",
          classNameImage
        )}
        placeholder={"blur"}
        blurDataURL={ImageConstant.BlurDataURL}
      />
      <div className={cn(`mt-2 flex flex-col gap-2 `, classNameTitle)}>
        <LinkElement
          href={"#"}
          className="text-gray-400 text-sm h-[18px] uppercase hover:text-red-500 transition-all"
        >
          {data?.tags[0]?.value || "all"}
        </LinkElement>
        <h3 className="text-lg font-semibold text-gray-500 hover:text-red-500 transition-all line-clamp-2 h-[48px]">
          {data.title}
        </h3>
        {subTitle === "children" ? (
          <p className="text-gray-400 text-sm h-[18px]">
            {data.total_story} bài viết
          </p>
        ) : (
          <TextDateTime
            className="text-gray-400 text-sm h-[18px]"
            ts={data.date_published || data.date_modified}
          />
        )}
      </div>
    </LinkElement>
  );
}
